import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.IncompletePage', {
    pageTitle: 'Wallets - Onboarding | {companyName} | Incomplete',
    title: 'Complete your application to unlock your account',
    fewMinutes: 'Completing the remaining steps will take just a few minutes.',
    onceAppSubmitted: `Once your application is fully submitted, our team will review your application, which typically
        takes about one business day. After that, you'll be able to access all the great features of your virtual account.`,
    continueOnboarding: 'Continue onboarding',
});
